import React from 'react';

import { getMyCompaniesWithInvestmentsTableColumns, INVESTOR_FUND_SHARES } from 'constants/investments';
import { CompanyWithInvestments } from 'interfaces';
import MyCompaniesWithInvestmentsTableItem from 'page-components/investments/my-investments/MyCompaniesWithInvestmentsTableItem';
import Table, { TableSkeleton } from 'shared-components/table';
import { filterDaxiaInvestments } from 'utils/investments';

import { TypographyVariants } from '../../constants/shared/typography';
import { TitleWithDescription } from '../../shared-components';
import NoCompaniesInvestments from './NoCompaniesInvestments';

interface Props {
  isLoading: boolean;
  list: CompanyWithInvestments[];
  hasInvestments: boolean;
}

const InvestorNumberOfShares = ({ isLoading, list, hasInvestments }: Props) => {
  return (
    <div>
      <TitleWithDescription title='Fund Shares' titleVariant={TypographyVariants.MEDIUM} />
      <Table columns={INVESTOR_FUND_SHARES}>
        {hasInvestments && !isLoading ? (
          <>
            {list.map((companyWithInvestments) => {
              const withoutDaxia = filterDaxiaInvestments(companyWithInvestments.investments);
              return withoutDaxia.map((investment, index) => (
                <MyCompaniesWithInvestmentsTableItem
                  key={investment.id}
                  investment={investment}
                  isFirstElement={index === 0}
                  companyId={companyWithInvestments.id}
                  companyName={investment?.companyName}
                  companyNumber={companyWithInvestments.companyNumber}
                  companyActiveShareExchange={companyWithInvestments.activeShareExchangeRequest}
                  disabledActions={!!companyWithInvestments.activeShareExchangeRequest}
                  declineReason={companyWithInvestments?.declineReason}
                  isActiveExchange={companyWithInvestments?.isActiveExchange}
                  shareExchangeRequestId={companyWithInvestments?.shareExchangeRequestId}
                  serDeclined={companyWithInvestments?.serDeclined}
                  userCompanySEStatus={companyWithInvestments?.userCompanySEStatus}
                />
              ));
            })}
          </>
        ) : isLoading ? (
          <TableSkeleton rowsNumber={3} columnsNumber={getMyCompaniesWithInvestmentsTableColumns().length} />
        ) : (
          <NoCompaniesInvestments entityName='Fund Shares' />
        )}
      </Table>
    </div>
  );
};

export default InvestorNumberOfShares;
